class FooterController extends AbstractController
	@register()
	@inject '$http',
		'ConfigurationService'
		'ENV'
		'API_ENDPOINT'
		'DEFAULT_TIMEZONE'
		'ADMIN_URL'
		'LanguageService'
		'DateService'
		'CredentialsManager'
		'UserInformation'

	initialize: ->
		@$http
			.get '/version'
			.then (response) => @version = 'v' + response.data

		@$http
			.get '/footer-structure.json'
			.then (response) =>
				@navItems = response.data

				angular.forEach @navItems, (item) =>
					switch item.hrefOrigin
						when "constant" then item.href = @[item.href]
						when "configuration" then item.href = @ConfigurationService.get(item.href, true)

				if @UserInformation.getMasterUser()?
					referrers = {
						adminsite:
							url: @ADMIN_URL + '/master-users/' + @UserInformation.getMasterUser().id
							title: 'menu.admin_site'
					}
					referrer = referrers[@CredentialsManager.getReferrer()]

					if referrer?
						@navItems.unshift({
							title: referrer.title
							href: referrer.url
						})

		@activeLanguage = @LanguageService.getDisplayLanguage()
		@languagesList = @LanguageService.getLanguages()
		@userTimezone = moment.tz.guess()
		@currentTimezone = @DateService.getTimezone()

	toggleTimezone: ->
		@DateService.toggleTimezone()
